import { createTask as createTaskRecord, deleteTasks } from "../../graphql/operations";

export const clearAllTasks = (companyId: string) => deleteTasks(companyId);

export const createTask = (taskData: Record<string, unknown>) => createTaskRecord(taskData);
